//@flow
import type { DisplayProduct } from 'core/service/display-product'
import { formattedHeaderWithStyles, productInfoHeaderStyles } from '../../common/components/product-information-header'

export const render = (displayProduct: DisplayProduct, selectedPlanCode: string, redline: string) => {
  const header1 = displayProduct.name
  const header2 = `${displayProduct.nameThai} (${selectedPlanCode})`
  return formattedHeaderWithStyles(header1, header2, redline, productInfoHeaderStyles)
}
